// CHG-1294 / ITER-3419 — tiny adapter between CHG-1290 GATE_CATALOG
// GateRule shape ({ permission, fallback? }) and the primitive prop
// shape ({ require, fallback? }) consumed by the CHG-1291/1292
// permissionGate fields on PageHeaderAction / BulkAction / and the
// CHG-1292 SettingsFormProps.savePermission slot.
//
// Why an adapter:
//   - GATE_CATALOG (CHG-1290) is an immutable framework artifact;
//     mutating its field names is out of scope.
//   - Primitive permissionGate prop shape was set by CHG-1291 and
//     mirrored by CHG-1292 across 3 more primitives; mutating those is
//     out of scope.
//   - Generator slot configs are the consumer surface. They can call
//     `toGate(GATE_CATALOG.donor_list["record-donation"])` to translate
//     between the two stable contracts without touching either side.
//
// Pure / synchronous. No hooks, no async, no side effects. Used in
// module scope inside generator slot config files.

import type { GateRule } from "./gateCatalog";

export interface PrimitiveGateProp {
  require: string;
  fallback?: "hide" | "disable";
}

/**
 * Convert a catalog GateRule → the {require, fallback?} prop shape used
 * by PageHeaderAction.permissionGate, BulkAction.permissionGate, and
 * SettingsFormProps.savePermission.
 *
 * If `overrideFallback` is supplied, it wins over the rule's own
 * `fallback` (lets call sites force "hide" for one affordance and
 * "disable" for another while sharing the same catalog entry).
 */
export function toGate(
  rule: GateRule,
  overrideFallback?: "hide" | "disable",
): PrimitiveGateProp {
  return {
    require: rule.permission,
    fallback: overrideFallback ?? rule.fallback,
  };
}

/** Convenience for DetailPageTab.permission which is just a code string. */
export function permissionOf(rule: GateRule): string {
  return rule.permission;
}
